import { cn } from "@/lib/utils";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "outline" | "accent";
  className?: string;
}

export function Badge({
  children,
  variant = "default",
  className,
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-medium leading-none",
        variant === "default" && "bg-foreground text-background",
        variant === "outline" && "border border-hair text-ink-50",
        variant === "accent" && "bg-accent/10 text-accent",
        className,
      )}
    >
      {children}
    </span>
  );
}
